import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import fa from 'vuetify/lib/locale/fa'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { fa },
        current: 'fa',
    },

    icons: {
        iconfont: 'fa', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    rtl: true,
    theme: {
        themes: {
            light: {
                primary: "#006aff",
                secondary: "#00388c",
                thirdColor: "#a005fa",

            },
        },
    },
});
